var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeOnSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5859375,2c-0.6357422,0-1.2578125,0.2578125-1.7070312,0.7070312L7.5859375,9H3c-1.6542969,0-3,1.3457031-3,3v8 c0,1.6542969,1.3457031,3,3,3h4.5859375l6.2929688,6.2929688C14.328125,29.7421875,14.9501953,30,15.5859375,30 C16.9169922,30,18,28.9169922,18,27.5859375V4.4140625C18,3.0830078,16.9169922,2,15.5859375,2z M16,27.5859375 c0,0.3378906-0.46875,0.5322266-0.7070312,0.2929688l-6.5859375-6.5859375C8.5195312,21.1054688,8.265625,21,8,21H3 c-0.5517578,0-1-0.4482422-1-1v-8c0-0.5517578,0.4482422-1,1-1h5c0.265625,0,0.5195312-0.1054688,0.7070312-0.2929688 l6.5859375-6.5859375C15.53125,3.8828125,16,4.0761719,16,4.4140625V27.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8994141,6.1005859l-1.4140625,1.4140625C28.7519531,9.78125,30,12.7949219,30,16 s-1.2480469,6.21875-3.5146484,8.4853516l1.4140625,1.4140625C30.5439453,23.2548828,32,19.7392578,32,16 S30.5439453,8.7451172,27.8994141,6.1005859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2431641,11.7568359c2.3388672,2.3398438,2.3388672,6.1464844,0,8.4863281l1.4140625,1.4140625 c3.1181641-3.1191406,3.1181641-8.1953125,0-11.3144531L22.2431641,11.7568359z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOnSmall);
export default __webpack_public_path__ + "static/media/volume-on--small.3e06163af60195f8a374a82599e88112.svg";
export { ForwardRef as ReactComponent };